
export class Http {
    static baseUrl = 'http://localhost:8080';
    static csrfToken = null;
    static bearerToken = null;
    static captchaToken = null;

    static configure(options) {
        this.baseUrl = options.baseUrl;
        this.DEBUG = options.debug;
        this.errorPolicy = options.errorPolicy || 'errorHandler';
        this.credentials = options.credentials || 'include';
    }

    static log(message) {
        if (this.DEBUG == null) { return; }
        console.log(message);
    }


    static setErrorHandler(onError) {
        this.onError = onError;
    }

    static report(code, resp, callback) {
        switch (this.errorPolicy) {
            case 'errorHandler':
                this.onError && this.onError(code, resp);
                break;

            case 'callback':
                callback(resp, code);
                break;
        }
    }

    static setBearerToken(token) {
        this.bearerToken = token;
    }

    static setCsrfToken(token) {
        this.csrfToken = token;
    }

    static setCatchaToken(token) {
        this.catchaToken = token;
    }

    static invalidateToken() {
        this.token = null;

        this.onTokenFailure &&
            this.onTokenFailure()

        this.onCaptchaFailure &&
            this.onCaptchaFailure()
    }

    static setOnTokenFailure(onTokenFailure) {
        this.onTokenFailure = onTokenFailure;
    }

    static setOnCaptchaFailure(onCaptchaFailure) {
        this.onCaptchaFailure = onCaptchaFailure
    }


    static headers() {
        const base = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        const { csrfToken, catchaToken, bearerToken } = this;

        return {
            ...base,
            ...(csrfToken ? { 'X-CSRF-TOKEN': csrfToken } : {}),
            ...(catchaToken ? { 'G-RECAPTCHA-RESPONSE': catchaToken } : {}),
            ...(bearerToken ? { 'Authorization': `Bearer ${bearerToken}` } : {})
        }
    }

    static GET(url, callback) {
        const baseUrl = Http.baseUrl;
        const requestUrl = baseUrl + '/' + url;

        this.run(
            fetch(requestUrl, {
                credentials: this.credentials,
                headers: this.headers()
            })
        , callback)
    }

    static CALL(url, params, method, callback) {
        const baseUrl = Http.baseUrl;
        const requestUrl = baseUrl + '/' + url;

        this.run(
            fetch(requestUrl, {
                method: method,
                redirect: 'follow',
                body: JSON.stringify(params||{}),
                credentials: this.credentials,
                headers: this.headers()
            })
        , callback);
    }

    static run(fetch, callback) {
        fetch
        .then(r => {
            if (r.status !== 200 && r.status !== 202) {
                throw r
            }

            return r.text()
        })
        .then(r => {
            const json = r.length>0 ? JSON.parse(r) : {}
            callback(json)
        })
        .catch(error => {
            this.log(error)
            error.json()
                .then(r => this.report(error.status, r, callback))
        })
    }

    static POST(url, params, callback) {
        this.CALL(url, params, 'post', callback)
    }

    static PUT(url, params, callback) {
        this.CALL(url, params, 'put', callback)
    }

    static DELETE(url, params, callback) {
        this.CALL(url, params, 'delete', callback)
    }
}
